import React, { FC } from "react";
import { Button } from "antd";
import '/site/parts/button-auth/button-auth.scss';
import {ButtonAuthProps} from "/react4xp/parts/button-auth/button-auth.type";

const ButtonAuth: FC<ButtonAuthProps> = (props: ButtonAuthProps) => {
  const { url, config, user } = props;

  return user ? null : (
    <Button type="primary" className="medium" onClick={() => open(url, '_self')}>
      {config.name}
    </Button>
  );
};

export default ButtonAuth;
